export type AppFlavor = 'development' | 'staging' | 'production';

const KNOWN_FLAVORS: readonly AppFlavor[] = ['development', 'staging', 'production'];

const BFF_BASE_URL: string = (() => {
  const value = process.env.EXPO_PUBLIC_BFF_BASE_URL;

  if (value) {
    return value;
  }

  throw new Error('Missing required environment variable: EXPO_PUBLIC_BFF_BASE_URL');
})();

const APP_FLAVOR: AppFlavor = (() => {
  const value = process.env.EXPO_PUBLIC_FLAVOR;

  if (value && KNOWN_FLAVORS.includes(value as AppFlavor)) {
    return value as AppFlavor;
  }

  throw new Error(
    `Missing or invalid environment variable: EXPO_PUBLIC_FLAVOR. Must be one of: ${KNOWN_FLAVORS.join(', ')}.`,
  );
})();

export { APP_FLAVOR, BFF_BASE_URL };
